export const Colors = [
    'Black',
    'Blue',
    'Brown',
    'Gray',
    'Orange',
    'Purple',
    'Red',
    'Silver',
    'White',
    'Other'
  ];

  export const Makes = [
    { name: 'Chevy', value: 'Chevy' },
    { name: 'Ford', value: 'Ford' },
    { name: 'Freightliner', value: 'Freightliner' },
    { name: 'GMC', value: 'GMC' },
    { name: 'Hino', value: 'Hino' },
    { name: 'International', value: 'International' },
    { name: 'Isuzu', value: 'Isuzu' },
    { name: 'Kenworth', value: 'Kenworth' },
    { name: 'Mack', value: 'Mack' },
    { name: 'Peterbilt', value: 'Peterbilt' },
    { name: 'Volvo', value: 'Volvo' },
    { name: 'Western Star', value: 'WesternStar' },
    { name: 'Other', value: 'Other' }
  ];